module.exports = __webpack_public_path__ + "img/yjbg.3b9222c5.png";